import { DRAW_CONSTS } from './constants-canvas'
/**
 * Move down labels y to avoid overlapping. Only labels with
 * index between `fromIndex` and `toIndex` are modified
 */
function moveLabelsDown(labelsY: number[], fromIndex: number, toIndex: number) {
  for (let i = fromIndex; i <= toIndex; i++) {
    if (labelsY[i] < labelsY[i - 1] + DRAW_CONSTS.LABEL_HEIGHT + DRAW_CONSTS.LABEL_MIN_GAP) {
      labelsY[i] = labelsY[i - 1] + DRAW_CONSTS.LABEL_HEIGHT + DRAW_CONSTS.LABEL_MIN_GAP
    }
  }
}
/**
 * Move up labels y to avoid overlapping. Only labels with
 * index between `fromIndex` and `toIndex` are modified
 */
function moveLabelsUp(labelsY: number[], fromIndex: number, toIndex: number) {
  for (let i = fromIndex; i >= toIndex; i--) {
    if (labelsY[i] > labelsY[i + 1] - DRAW_CONSTS.LABEL_HEIGHT - DRAW_CONSTS.LABEL_MIN_GAP) {
      labelsY[i] = labelsY[i + 1] - DRAW_CONSTS.LABEL_HEIGHT - DRAW_CONSTS.LABEL_MIN_GAP
    }
  }
}
/**
 * Move first and last labels y position inside interval `[0,upperBound]`
 */
function moveBoundsInside(labelsY: number[], upperBound: number) {
  labelsY[0] = Math.max(labelsY[0], DRAW_CONSTS.LABEL_MARGIN)

  labelsY[labelsY.length - 1] = Math.min(
    labelsY[labelsY.length - 1],
    upperBound - DRAW_CONSTS.LABEL_HEIGHT - DRAW_CONSTS.LABEL_MARGIN
  )
}

export function moveLabels(ys: number[], canvasHeight: number) {
  if (ys.length === 1) {
    ys[0] = (canvasHeight + DRAW_CONSTS.LABEL_HEIGHT) / 2
  } else {
    // Starting from middle point move the other
    const middle = Math.ceil((ys.length - 1) / 2)

    moveLabelsUp(ys, middle - 1, 1)
    moveLabelsDown(ys, middle + 1, ys.length - 1)

    moveBoundsInside(ys, canvasHeight)
    moveLabelsDown(ys, 1, ys.length - 1)

    moveBoundsInside(ys, canvasHeight)
    moveLabelsUp(ys, ys.length - 2, 1)
  }
}
